import { render, staticRenderFns } from "./ProductList.pug?vue&type=template&id=9fffe1a6&scoped=true&lang=pug&"
import script from "./ProductList.js?vue&type=script&lang=js&"
export * from "./ProductList.js?vue&type=script&lang=js&"
import style0 from "./ProductList.sass?vue&type=style&index=0&id=9fffe1a6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fffe1a6",
  null
  
)

component.options.__file = "ProductList.vue"
export default component.exports